import type { Client } from '@core/api/utils';
import { pipeData, toSkipErrorHandlingConfig } from '@core/api/utils';
import { config } from './config';
import { toClassDetail, toFriendsList } from './mappers';

const toClassUrl = (id: string) =>
  `/api/ride/${id}/details?stream_source=${config.streamSource}&include=sampled_top_tags&include=in_class_playlist`;
const toFriendsWhoHaveTakenClassUrl = (id: string) =>
  `api/ride/${id}/recent_following_workouts?joins=user&limit=200`;

// Re-export types for backwards compatibility
export type {
  ApiSegment,
  ApiSegments,
  Averages,
  ApiClassDetail,
  ApiFriendsResponse,
} from './apiTypes';

export const fetchClassDetail = (api: Client, id: string) =>
  api
    .get(toClassUrl(id), { ...toSkipErrorHandlingConfig({}, { 403: true }) })
    .then(pipeData(toClassDetail));

export const fetchFriendsWhoHaveTakenClass = (api: Client, id: string) =>
  api
    .get(toFriendsWhoHaveTakenClassUrl(id), {
      ...toSkipErrorHandlingConfig({}, { 403: true }),
    })
    .then(pipeData(toFriendsList));

export type ClassDetailResponse = ReturnType<typeof toClassDetail>;
